import styled from 'styled-components';

export const FlexColumn = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Content = styled(FlexColumn)`
	gap: 12px;
`;

export const MessageContainer = styled(FlexColumn)`
	margin-bottom: 8px;

	[data-mobile='true'] & {
		input {
			font-size: 16px;
			min-height: 44px;
			padding: 12px;
		}
	}
`;

export const TextInput = styled.div`
	background: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 2px;
	padding: 6px;
	padding-top: 4px;
	width: 100%;
	box-sizing: border-box;

	[data-mobile='true'] & {
		padding: 12px;
		padding-top: 8px;

		input {
			font-size: 16px;
			min-height: 44px;
		}
	}

	input {
		background: transparent;
		border: none;
		width: 100%;
		margin: 0;
		padding: 0;

		&:focus {
			outline: none;
		}
	}
`;

export const MultilineInput = styled.div`
	& :focus {
		border: 1px solid ${({ theme }) => theme.gray[700]};
	}

	[data-mobile='true'] & {
		textarea {
			font-size: 16px;
			min-height: 120px;
			padding: 12px;
		}
	}
`;

export const Error = styled.p`
	margin: 0;
	font-size: 12px;
	padding: 1px 0 4px 0;
	color: ${(p) => p.theme.red[500]};
`;
